import { render, staticRenderFns } from "./StopInsurance.vue?vue&type=template&id=8ed15de0&scoped=true"
import script from "./StopInsurance.vue?vue&type=script&lang=js"
export * from "./StopInsurance.vue?vue&type=script&lang=js"
import style0 from "./StopInsurance.vue?vue&type=style&index=0&id=8ed15de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed15de0",
  null
  
)

export default component.exports